import React from 'react'
import { IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      style={{
        display: 'block',
        padding: '10px'
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  )
}

export default BackButton
